var windowWidth,lazyImages,lazyBackground,lazyIframe,lazyScripts,src,style,datasrc,urls,analytics,s,x,i,j,flag;
document.addEventListener("DOMContentLoaded", function() {
	windowWidth = screen.width;
	lazyImages = document.querySelectorAll('img.lazy2');
	nolazyImages = document.querySelectorAll('img.lazy');
	lazyBackground = document.querySelectorAll('.lazybg');
	lazyIframe = document.querySelectorAll('iframe');
	lazyScripts = document.getElementsByTagName("script");
	i=0;
	j=0;
	flag=1;

//	lazyLoadImg2();

	window.addEventListener("scroll", function() {
		init();
	});
	window.addEventListener("mousemove", function() {
		init();
	});
	window.addEventListener("touchstart", function() {
		init();
	});
	setTimeout(function() {
		init();
	}, 60000);
});
function init() {
	if(flag) {
		flag=0;
		lazyLoadImg();
		lazyLoadBackground();
		lazyLoadIframe();
		load_all_js();
	}
}
function isElementInViewport (el) {
	var rect = el.getBoundingClientRect();

	return (
		rect.top >= 0 &&
		rect.left >= 0 &&
		rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && /* or $(window).height() */
		rect.right <= (window.innerWidth || document.documentElement.clientWidth) /* or $(window).width() */
	);
}
function lazyLoadImg() {
	lazyImages.forEach(function(elem) {
		if( windowWidth < 600 )
			src = (elem.dataset.mobsrc == undefined) ? elem.dataset.src : elem.dataset.mobsrc;
		else
			src = elem.dataset.src;

		if( src != null )
			elem.src = src;

		elem.classList.remove("lazy2");
	});
}
function lazyLoadImg2() {
	lazyImages.forEach(function(elem) {
		if( isElementInViewport(elem) ) {
			if( windowWidth < 600 )
				src = (elem.dataset.mobsrc == undefined) ? elem.dataset.src : elem.dataset.mobsrc;
			else
				src = elem.dataset.src;

			if( src != null )
				elem.src = src;

			elem.classList.remove("lazy");
		}
	});
}
function lazyLoadBackground() {
	lazyBackground.forEach(function(elem) {
		if( windowWidth < 600 )
			lazybg = (elem.dataset.mobstyle == undefined) ? elem.dataset.style : elem.dataset.mobstyle;
		else
			lazybg = elem.dataset.style;

		if( lazybg != null )
			elem.style = lazybg;

		elem.classList.remove("lazybg");
	});
}
function lazyLoadIframe() {
	lazyIframe.forEach(function(elem) {
		elem.src = (elem.dataset.src == undefined) ? elem.src : elem.dataset.src;
	});
}
function lazyLoadScripts() {
	if (j == lazyScripts.length)
		return;

	if ( lazyScripts[j].getAttribute("type") == "lazyload2" ) {
		lazyScripts[j].setAttribute("type", "lazyloaded");
		if (typeof lazyScripts[j].dataset.src !== 'undefined') {
			s=document.createElement("script");
			s.src=lazyScripts[j].dataset.src;
			document.body.appendChild(s);
			s.onload=function() {
				j++;
				lazyLoadScripts();
			};
		} else {
			s=document.createElement("script");
			s.innerHTML=lazyScripts[j].innerHTML;
			document.body.appendChild(s);
			j++;
			lazyLoadScripts();
		}
	} else {
		j++;
		lazyLoadScripts();
	}
}
function lazyLoadCss(url) {
	s=document.createElement("link");
	s.rel="stylesheet";
	s.href=url;
	document.getElementsByTagName("head")[0].appendChild(s);
}
function lazyLoadJS(url) {
	s=document.createElement("script");
	s.src=url;
	document.body.appendChild(s);
}
function load_all_js() {
	if(document.querySelectorAll('#lazycss') != null){
		document.querySelectorAll('#lazycss').forEach(function(elem) {
		  elem.href = elem.getAttribute('data-href');   
		});
	}

	//lazyLoadCss("//cdn.shopify.com/s/files/1/0388/2496/8237/t/4/assets/theme.scss.css?v=8769620966383583307");

	
		setTimeout(function() {
			const wnw_load = new Event('wnw_load');
			window.dispatchEvent(wnw_load);
		}, 100);
	

	/// lazyLoadJS("https://cdn.shopify.com/s/assets/storefront/load_feature-24ff1222c9aa13bb217653c0d3ea28c40a796a280e6da29ad421eec2a6075c86.js");
	/// lazyLoadJS("https://cdn.shopify.com/s/assets/storefront/features-87e8399988880142f2c62771b9d8f2ff6c290b3ff745dd426eb0dfe0db9d1dae.js");

	j=0;
	lazyScripts = document.getElementsByTagName("script");
	lazyLoadScripts();

	setInterval(function() {
		lazyImages = document.querySelectorAll('img.lazy2');
		lazyBackground = document.querySelectorAll('.lazybg');
		lazyLoadImg();
		lazyLoadBackground();
	}, 3000);
}
if(document.querySelectorAll('img.desktopload') != null) {
	let i = 0;
	document.querySelectorAll('img.desktopload').forEach(function(elem) {
		if(i == 0) {
			var str = elem.getAttribute('data-src');
			var src = str.replace("{width}", "800");
			elem.src = src;
			elem.style.opacity = '1';
			i++;
		}
	});
}